import { ScaleMode } from '../Enums';

export default class URLPlayer {
    constructor(testElement, uiService) {
        this.signal = null;
        this.testElement = testElement;
        this.startLoading = [];
        this.endLoading = [];
        this.isStarted = false;
        this.isSkipped = false;
        this.displayTimeout = null;
        this.position = null;
        this.updateTimerTimeout = null;
        this.stateChangedCallback = null;
        this.isPreloaded = false;
        this.isActive = false;
        this.URLElement = document.createElement('iframe');
        this.URLElement.setAttribute("id","urlplayeriframe");
        this.countDown = document.getElementById('url-player-timer');
        this.isPreloaded = true;
        this.uiService = uiService;
        this.startTime = null;
    }

    start() {
        return new Promise((resolve) => {
            this.URLElement.src = this.testElement.url;
            this.signal = resolve;
            this.stateChanged();
            this.isStarted = true;
            this.isSkipped = false;
            var remainingTime = this.testElement.cutoffTime;
            this.startTime = Date.now();
            this._show();

        this.timer = 0;
        if (this.updateTimerTimeout) {
            clearTimeout(this.updateTimerTimeout);
        }

        const updateTimer = () => {
            return setTimeout(() => {
                this.timer += 1000;
                remainingTime = remainingTime - 1000;

                var seconds = Math.floor(remainingTime/1000);
                var minutes = Math.floor(seconds/60);
                if (this.countDown) {
                    this.countDown.innerText = ('0' + minutes).slice(-2) +':' + ('0' + (seconds - 60*minutes)).slice(-2);
                }

                if (this.timer < this.testElement.cutoffTime) {
                    this.updateTimerTimeout = updateTimer();
                } else {
                    clearTimeout(this.updateTimerTimeout);
                    this.onStop();
                }
            }, 1000);
        }; 

        this.updateTimerTimeout = updateTimer();
        this.stateChanged();
        });
    }

    getPosition() {
        if (!this.startTime) {
            return null;
        }

        const res = {};
        res.elementId = this.testElement.testElementSequenceID;        
        res.position = Date.now() - this.startTime;
        return res;
    }

    stateChanged() {
        if (this.stateChangedCallback) {
            try {
                this.stateChangedCallback(this.testElement);
            }
            catch (e) { }
        }
    }

    onStateChange(clbck) {
        if (clbck) {
            this.stateChangedCallback = clbck;
        }
    }

    onStop() {
        this.stateChanged(this.testElement);
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }

        if (this.updatePositionTimeout) {
            clearTimeout(this.updatePositionTimeout);
        }

        this.isActive = false;
        this._hide();
        this.isStarted = false;
        this.signal();
    }

    close() {
        if (this.isStarted) {
            this.onStop();
        }
    }

    _show() {
        const URLPlayerElement = document.getElementById('URLPlayer');
        if (!this.testElement || !URLPlayerElement) {
            return;
        }

        URLPlayerElement.appendChild(this.URLElement);
        this.isActive = true;
        this.uiService.switchScreen('#URLPlayer');
       
    }

    skip() {
        clearTimeout(this.displayTimeout);
        this.isSkipped = true;
        this.onStop();
    }

    _hide() {
        const URLPlayerElement = document.getElementById('URLPlayer');
        URLPlayerElement.removeChild(this.URLElement);
         if (this.cutoffTimer) {
            this.cutoffTimer.innerText = '';
        }

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}